
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import { ModelListSelect } from "vue-search-select";

@Component({ components: { ModelListSelect } })
export default class UpdateParentUserComponent extends Vue {
  @Prop() public data;
  public parentId = null;
  public parentUserList = [];
  public disableSubmitbutton = false;

  public async validateAndSubmit() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      if (this.parentId != this.data.parentId) {
        this.disableSubmitbutton = true;
        this.$showLoader(true);
        let response = await Axios.post(
          API_STORE.CONFIG + "updateParentUser",
          {
            parentId: this.parentId,
            userId: this.data.userId,
          },
          {
            headers: getAPIAuthorizedHeader(),
          }
        );
        this.$showLoader(false);
        this.disableSubmitbutton = false;
        if (response) {
            this.$snotify.success(response.data.message);
            this.$emit("updateParentUser", true);
        } else this.$snotify.error("This parent have already assigned");
      }
    }
  }

  resetForm() {
    this.$emit("cancel", true);
  }

  public async getUserBySubdomain() {
    let response = await Axios.get(API_STORE.CONFIG + "getUserBySubdomain", {
      params: {
        subdomain: this.data.subdomain,
        userId: this.data.userId,
        userType: this.data.userType,
      },
      headers: getAPIAuthorizedHeader(),
    });
    if (response && response.data) {
      this.parentUserList = response.data.parentUserList;
    }
  }

  userNameAndUserType(item) {
    return `${item.name} (${this.$getUserTypeBasedOnId(item.userType)})`;
  }
  mounted() {
    this.parentId = this.data.parentId;
    this.getUserBySubdomain();
  }
}
